import script from "./LiuShaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LiuShaTable.vue?vue&type=script&setup=true&lang=js"

import "./LiuShaTable.vue?vue&type=style&index=0&id=3c94396f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c94396f"]])

export default __exports__